module.exports = __webpack_public_path__ + "img/debian.dfab534e.svg";